export const NSFW_DISABLED_LS_KEY = 'nsfw-disabled';

/**
 * Cards containing this tag in the note or in the value note
 * would be blurred when NSFW mode is disabled.
 */
export const NSFW_TAG = '@NSFW';
